"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _embed = require("../../constants/embed");

function EmbedIframe(props) {
  var inpage = props.inpage,
      embedId = props.embedId,
      style = props.style,
      iframeRef = props.iframeRef;

  var getSource = function getSource() {
    var query = encodeURIComponent("id=" + embedId + "&inpage=" + inpage + "&origin=" + window.location.origin);
    return _embed.CONTENT_EMBED_UI_BASE_URL + "?" + query;
  };

  var getKey = function getKey() {
    return "hs-iframe-embed-" + embedId;
  };

  return _react.default.createElement("iframe", {
    key: getKey(),
    "data-test-id": "hs-content-embed-iframe",
    style: style,
    contentEditable: false,
    src: getSource(),
    sandbox: "allow-scripts allow-same-origin",
    referrerPolicy: "strict-origin",
    ref: function ref(el) {
      return iframeRef(el);
    }
  });
}

EmbedIframe.propTypes = {
  inpage: _propTypes.default.bool.isRequired,
  embedId: _propTypes.default.string.isRequired,
  style: _propTypes.default.object,
  iframeRef: _propTypes.default.func
};
EmbedIframe.defaultProps = {
  iframeRef: function iframeRef() {}
};
var _default = EmbedIframe;
exports.default = _default;
module.exports = exports.default;